export default {
  DEFAULT: '',
  PENDING: 'Fetch/Pending',
  SUCCESS: 'Fetch/Success',
  ERROR: 'Fetch/Error'
}